import '../../index.css';
import { useEffect, useState } from 'react';
import { useSearchParams, createSearchParams, useNavigate } from 'react-router';
import { Errors } from '../../types/errors';
import { failure, unauthorized } from '../../types/api';
import { BoardingModule, ConfigInfoProps, Phase } from '../configLookup/components/Props';
import apiFunctions from '../../api';
import ConfigAccordion from './components/ConfigAccordion';
import BoardingModules from './components/BoardingModules';
import Phases from './components/Phases';
import PhaseInfo from './components/PhaseInfo';
import SubFlows from './components/SubFlows';
import { VegaBox, VegaGrid } from '@globalpayments/vega-react';
import PageSkeleton from '../../components/pageSkeleton';

const ConfigInfo = () => {
  const [searchParams] = useSearchParams();
  const configid = Number(searchParams.get('id'));

  const [config, setConfig] = useState<ConfigInfoProps | null>(null);
  const [boardingModules, setBoardingModules] = useState<BoardingModule[] | null>(null);
  const [phases, setPhases] = useState<Phase[] | null>(null);
  const [phase, setPhase] = useState<Phase | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let subscribed = true;

    const getConfigDetails = async () => {
      await apiFunctions
        .apiPost('Kirby/ConfigDetails/GetConfigDetails', { OnDemandConfigId: configid })
        .then((data) => {
          if (!subscribed) return;

          if (data === failure) {
            navigate({
              pathname: '/error',
              search: `?${createSearchParams({ errType: Errors.CallFailed })}`,
            });
            setLoading(false);
            return;
          } else if (data === unauthorized) {
            navigate({
              pathname: '/error',
              search: `?${createSearchParams({ errType: Errors.Unauthorized })}`,
            });
            setLoading(false);
            return;
          }

          setConfig(data);
          setLoading(false);
        });
    };

    if (loading && subscribed) {
      getConfigDetails();
    }

    return () => {
      subscribed = false;
    };
  }, [configid, loading, navigate]);

  if (loading) {
    return <PageSkeleton label="Loading config details" variant="detail" />;
  }

  if (config == null) return null;

  return (
    <VegaBox>
      <ConfigAccordion config={config} />
      <VegaBox margin={{ top: 'size-40' }}>
        <VegaGrid column={{ default: 1, L: 2, XL: 4 }} gap="size-24">
          <SubFlows SubFlows={config.subFlows} setBoardingModules={setBoardingModules} />
          {boardingModules !== null ? (
            <BoardingModules boardingmodules={boardingModules} setPhases={setPhases} setPhase={setPhase} />
          ) : null}
          {phases !== null ? <Phases phases={phases} setPhase={setPhase} /> : null}
          {phase !== null ? <PhaseInfo phase={phase} /> : null}
        </VegaGrid>
      </VegaBox>
    </VegaBox>
  );
};

export default ConfigInfo;
